import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../API/axiosNeatex';
import type { OrganizationDataToZatcaModels } from './zatcaModels';

export const getOrganizationDataToZatca = createAsyncThunk(
  'Zatca/getOrganizationDataToZatca',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('Zatca/GetOrganizationDataToZatca');
      if (data?.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const generatecsr = createAsyncThunk(
  'Zatca/generatecsr',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Zatca/generatecsr', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getccsid = createAsyncThunk(
  'Zatca/getccsid',
  async (item: any, { rejectWithValue }) => {
    try {
      // const { data } = await ntxAPI.post(`Zatca/getccsid?csr=${item.csr}&OTP=${item.OTP}`);

      const { data } = await ntxAPI.post(
        `Zatca/getccsid?csr=${item.csr}&OTP=${item.OTP}`,
        {}, // إذا لم تكن هناك بيانات في body، قم بتمرير كائن فارغ
        {
          headers: {
            environmentType: item.environmentType, // إضافة الهيدر المطلوب
          },
        }
      );
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// export const getccsid = createAsyncThunk(
//   'Zatca/getccsid',
//   async (payload: { params: any; headers: any }, { rejectWithValue }) => {
//     try {
//       const { params  , headers } = payload;
//       const { data } = await ntxAPI.get('Zatca/getccsid', {
//         params, // تحديد البارامترات هنا
//         headers, // إضافة الـ headers
//       });      return data;
//     } catch (error: any) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

const initialState: {
  OrganizationDataToZatca: OrganizationDataToZatcaModels;
  csr: string;
  privateKey: string;
  ccsidComplianceRequestId: string;
  ccsidBinaryToken: string;
  ccsidSecret: string;
  loading: boolean;
  error: any | null;
} = {
  OrganizationDataToZatca: {} as OrganizationDataToZatcaModels,

  csr: '',
  privateKey: '',
  ccsidComplianceRequestId: '',
  ccsidBinaryToken: '',
  ccsidSecret: '',

  // ~~~~~
  loading: false,
  error: null,
};

const PurchaseBillSlice = createSlice({
  name: 'Zatca',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(getOrganizationDataToZatca.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getOrganizationDataToZatca.fulfilled,
        (state, action: PayloadAction<OrganizationDataToZatcaModels>) => {
          state.loading = false;
          state.OrganizationDataToZatca = action.payload;
        }
      )
      .addCase(getOrganizationDataToZatca.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      //~~~~~~~~~~~

      .addCase(generatecsr.pending, (state) => {
        state.loading = true;
      })
      .addCase(generatecsr.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.csr = action.payload.csr;
        state.privateKey = action.payload.privateKey;
      })
      .addCase(generatecsr.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //~~~~~~~~~~~

      .addCase(getccsid.pending, (state) => {
        state.loading = true;
      })
      .addCase(getccsid.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.ccsidBinaryToken = action.payload.ccsidBinaryToken;
        state.ccsidSecret = action.payload.ccsidSecret;
        state.ccsidComplianceRequestId = action.payload.ccsidComplianceRequestId;
      })
      .addCase(getccsid.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default PurchaseBillSlice.reducer;
